import React from "react";

const Navbar = () => {
    const handleScrollToSection = (sectionId) => {
        if (sectionId === "top") {
            window.scrollTo({
                top: 0, // Scrolls to the absolute top of the page
                behavior: "smooth",
            });
        } else {
            const section = document.getElementById(sectionId);
            if (section) {
                const navbarHeight = document.querySelector(".navbar").offsetHeight; // Get the navbar height
                const sectionPosition = section.offsetTop - navbarHeight; // Adjust for navbar height
                window.scrollTo({
                    top: sectionPosition,
                    behavior: "smooth",
                });
            }
        }
    };

    return (
        <nav
            className="navbar"
            style={{
                padding: "10px",
                backgroundColor: "#004d40",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                color: "white",
            }}
        >
            {/* Logo */}
            <div
                onClick={() => handleScrollToSection("top")}
                style={{
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none",
                    cursor: "pointer",
                }}
            >
                <img
                    src="/favicon.ico"
                    alt="Indien Buddy Logo"
                    style={{
                        height: "40px",
                        width: "45px",
                        marginRight: "10px",
                        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                        borderRadius: "8px",
                    }}
                />
                <h1
                    style={{
                        fontSize: "1.5rem",
                        margin: 0,
                        fontWeight: "normal",
                        color: "white",
                        fontFamily: "Arial, sans-serif",
                    }}
                >
                    Indien Buddy
                </h1>
            </div>

            {/* Navigation Links */}
            <div>
                <span
                    onClick={() => handleScrollToSection("services")}
                    style={{
                        margin: "0 15px",
                        textDecoration: "none",
                        color: "white",
                        cursor: "pointer",
                    }}
                >
                    Services
                </span>
                <span
                    onClick={() => handleScrollToSection("about")}
                    style={{
                        margin: "0 15px",
                        textDecoration: "none",
                        color: "white",
                        cursor: "pointer",
                    }}
                >
                    About
                </span>
                <span
                    onClick={() => handleScrollToSection("contact")}
                    style={{
                        margin: "0 15px",
                        textDecoration: "none",
                        color: "white",
                        cursor: "pointer",
                    }}
                >
                    Contact
                </span>
            </div>
        </nav>
    );
};

export default Navbar;
